/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
const logger = require('od-modules/utils/logger');

module.exports = (function() {
    'use strict';
    var PaymentErrorManager = require('../models/paymenterrormanager.model');

    return Backbone.Collection.extend({
        updateErrorsCollection: function(errorData) {
            Odigeo._.each(Odigeo._.isArray(errorData) ? errorData : [errorData], function(error) {
                this.addErrorToCollection(error);
            }, this);
        },

        addErrorToCollection: function(error) {
            var paymentError = new PaymentErrorManager(error);
            this.fillModelWithData(paymentError);
            this.add(paymentError);
        },

        fillModelWithData: function(errorModel) {
            this.setErrorId(errorModel);

            // If we already passed a description text to model it means we don't want to search for a message
            if (errorModel.get('description') === '') {
                this.mapErrorWithMessage(errorModel);
            }
        },

        setErrorId: function(error) {
            var lastError = this.last();
            error.set('id', Odigeo._.isUndefined(lastError) ? 1 : lastError.get('id') + 1);
        },

        // Finds, by type, a match between error sent and errorMessages passed through widget options.
        // and sets the corresponding message to error model
        mapErrorWithMessage: function(error) {
            var errorDescription = Odigeo._.find(this.errorMessages, {type: error.get('type')}, this);
            if (!Odigeo._.isUndefined(errorDescription)) {
                error.set('description', errorDescription.value);
            } else {
                const errorMessage = `Error type (${error.get('type')}) not found in error messages,
                make sure you send the correct type to widget options`;
                logger.message(errorMessage);
                throw new Error(errorMessage);
            }
        },
    });
})();
